import messages from '../../../locale/messages';
import valid from 'card-validator';

const validate = values => {
  const errors = {
    count: 0,
  };

  if (!values.cardId) {
    errors.card = 'Card selection requred';
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/Booking/Payment/validate.js